<template>
    <div class="user" style="padding-top: 1rem;">
        <navTitle :title="$router.app._route.query.ti ? $router.app._route.query.ti : 'Nomor Akun'" font="#fff"
                  color="#00c3f9" v-bind:isback="false"></navTitle>
        <div v-if="christmas_decoration===1" class="decorate"></div>
        <div v-if="christmas_decoration===2" class="decorate1"></div>
        <div class="headerbg bg-color-blue"></div>
        <div class="header acea-row row-between-wrapper">
            <div class="user-info">
                <div class="user-head">
                    <img v-if="christmas_decoration===1" @click="changeAvatar" class="hat" src="../../assets/images/santa_hat.gif"/>
                    <img v-if="christmas_decoration===2" @click="changeAvatar" class="hat1" src="../../assets/images/year/new_year6.gif"/>
                    <img v-if="is_club_user" @click="changeAvatar" class="crown" src="../../assets/images/af.gif"/>
                    <div class="user-avatar bg" @click="changeAvatar">
<!--                        <img class="avatar" :src="userInfo.avatar" alt=""/>-->
                        <img v-if="userInfo.avatar.indexOf('https') !=-1" :src="userInfo.avatar" alt=""/>
                        <img v-else :src="avatar_path+userInfo.avatar" alt=""/>
                    </div>
                    <div class="avatar_flag" v-if="avatar_flag">
                        <div class="switch-item" :class="switch_index===index?'switch-click':''"
                             v-for="(item,index) in user_avatar_list" v-key="index"
                             @click="switchItem(item,index)">
                            <div class="user-avatar avatar-item">
                                <img :src=avatar_path+item alt=""/>
                            </div>
                        </div>
                    </div>
                    <div class="user-name">
                        <div class="acea-row row-middle" style="margin-bottom: 0.2rem">
                            <div class="name line1">{{ userInfo.nickname }}</div>
                            <div class="member acea-row row-middle" v-if="userInfo.vip">
                                <img class="vip-icon" :src="userInfo.vip_icon"/>{{userInfo.vip_name}}
                            </div>
                            <!--<div @click="googleBind">
                                <svg t="1665626796615" font-size="32px" class="icon" viewBox="0 0 1024 1024"
                                     version="1.1"
                                     xmlns="http://www.w3.org/2000/svg" p-id="2589" width="128" height="128">
                                    <path d="M859.553531 223.46735c-131.266167-0.273397-251.874989-45.271187-347.712244-120.449085-95.882309 75.019185-216.28634 120.176713-347.417344 120.449085-87.404969 286.237962 63.019433 593.928847 347.531004 697.515408C796.534098 817.396197 946.982051 509.705312 859.553531 223.46735zM201.448179 514.182052l310.551821 0L512 160.980375c92.522706 64.419182 199.064407 101.307233 311.691485 107.939403 19.76237 82.987619 18.331902 166.81181-1.178574 245.262275L512 514.182052 512 871.126293c-0.015359 0.006144-0.029695 0.012287-0.045054 0.018431C352.376368 807.140244 240.559241 671.464918 201.448179 514.182052z"
                                          p-id="2590" fill="#00c3f9"></path>
                                </svg>
                            </div>-->
                            <span class="star-container" style="margin-top: -5px">
                                <img style="height: 32px;float:left" src="../../assets/images/star.gif">
                                <lable style="display: block;margin-left: 25px;position: absolute;margin-top: 14px;font-weight: bold;color: #FFA500">{{club_points_info['accumulated_points']}}</lable>
                            </span>
                        </div>
                        <router-link :to="'/user/data'" class="id" v-if="userInfo.phone">
                            ID:{{ userInfo.uid || 0 }}<span class="iconfont icon-bianji1"></span>
                        </router-link>
                        <router-link :to="'/user/binding'" class="bindingPhone" v-else>
                            <span>Link phone number now</span>
                        </router-link>
                    </div>
                </div>
                <div class="user-currency">
                    <div class="currency">
                        <div class="integral">{{ userInfo.now_money | MoneyFormat }}</div>
                        <div class="currency-name">Saldo tersedia({{icon_moeny}})</div>
                    </div>
                    <div class="currency">
                        <div class="integral">{{ userInfo.integral }}</div>
                        <div class="currency-name">Poin saya</div>
                    </div>
                </div>
            </div>

            <!--<div class="code" style="margin-top:.2rem;padding: .2rem .1rem;background-color: #fff;border-radius: 8px;float: left;">
                Kode aktivitas <input class="input" style="border: 1px solid red;" placeholder="Memasukkan kode" v-model="exchange_code"/>
                <div class="pay-btn bg-color-blue"
                     style="margin-top: .2rem;padding: .1rem .1rem;border-radius: 5px;color: #fff;" @click="exchangeCode">Kirimkan
                </div>
            </div>-->

            <!--<div class="flex-container">
                <div class="flex-item">Kode aktivitas</div>
                <div class="flex-item"><input class="input" placeholder="Memasukkan kode" v-model="exchange_code"/>
                </div>
                <div class="flex-item button1" @click="exchangeCode">Kirimkan</div>
            </div>-->


            <div class="google-authenticator-btn bg-color-blue" style="float: left" @click="goActivityArea">
                <div>
                    <div style="float: left;">
                        <!--<svg style="font-size: .6rem;position:absolute;margin-top: 5px;margin-left: 35px" t="1665631320339" class="icon" viewBox="0 0 1024 1024" version="1.1"
                             xmlns="http://www.w3.org/2000/svg" p-id="5329" width="128" height="128">
                            <path d="M512 85.333333c235.637333 0 426.666667 191.029333 426.666667 426.666667S747.637333 938.666667 512 938.666667 85.333333 747.637333 85.333333 512 276.362667 85.333333 512 85.333333z m0 64c-200.298667 0-362.666667 162.368-362.666667 362.666667s162.368 362.666667 362.666667 362.666667 362.666667-162.368 362.666667-362.666667-162.368-362.666667-362.666667-362.666667z m21.141333 132.298667a54.762667 54.762667 0 0 1 29.312 29.749333l37.365334 91.456 96.693333 7.893334c30.122667 2.453333 52.352 29.013333 49.984 59.125333a55.104 55.104 0 0 1-18.677333 37.205333l-74.08 64.597334 22.666666 96.746666c6.88 29.333333-11.008 58.944-40.309333 66.058667a54.218667 54.218667 0 0 1-41.44-6.656L512 676.416l-82.666667 51.392a54.325333 54.325333 0 0 1-75.338666-18.346667 55.317333 55.317333 0 0 1-6.4-41.056l22.666666-96.746666-74.08-64.597334a55.253333 55.253333 0 0 1-5.909333-77.098666 54.421333 54.421333 0 0 1 37.216-19.242667l96.693333-7.893333 37.365334-91.445334c11.498667-28.128 43.584-41.6 71.594666-29.749333zM512 357.109333l-30.72 75.178667a54.592 54.592 0 0 1-46.037333 33.856l-81.024 6.613333 62.165333 54.197334a55.210667 55.210667 0 0 1 17.386667 54.186666l-18.805334 80.234667 68.373334-42.506667a54.218667 54.218667 0 0 1 57.312 0l68.373333 42.506667-18.794667-80.234667a55.210667 55.210667 0 0 1 17.386667-54.186666l62.165333-54.197334-81.024-6.613333a54.592 54.592 0 0 1-46.048-33.856L512 357.109333z"
                                  p-id="5330" fill="#ffffff"></path>
                        </svg>-->
                        <!--<svg style="font-size: .6rem;position:absolute;margin-top: 5px;margin-left: 35px"
                             t="1634609378958" class="icon" viewBox="0 0 1024 1024" version="1.1"
                             xmlns="http://www.w3.org/2000/svg" p-id="4793" width="200" height="200">
                            <path d="M154 283.788C229.456 165.47 361.86 87 512.594 87c164.43 0 307.05 93.379 377.724 230H512.594c-87.46 0-161.47 57.577-186.196 136.894L154 283.788z"
                                  fill="#DD5044" p-id="4794"></path>
                            <path d="M494.83 936.635l0.476-0.989-0.569 0.986-0.54-0.023 61.103-234.3C642.455 682.836 707.594 605.025 707.594 512c0-107.56-87.085-194.78-194.594-195h377.318c30.212 58.403 47.276 124.709 47.276 195 0 234.721-190.28 425-425 425-5.95 0-11.873-0.122-17.764-0.365z"
                                  fill="#FFCD41" p-id="4795"></path>
                            <path d="M491.977 936.509C266.83 925.755 87.594 739.809 87.594 512c0-70.105 16.974-136.246 47.037-194.537l17.04-29.981c0.77-1.236 1.546-2.467 2.329-3.694l172.398 170.106c-5.722 18.353-8.804 37.87-8.804 58.106 0 107.696 87.304 195 195 195 14.67 0 28.962-1.62 42.707-4.69l-58.797 225.454L494 935l-2.023 1.509z"
                                  fill="#17A05D" p-id="4796"></path>
                            <path d="M494.747 936.615l-0.545-0.023 61.074-234.187c53.77-11.885 99.2-45.966 126.192-92.14l1.273 0.735-187.994 325.615zM154.373 283.84l0.033-0.052 172.398 170.106C321.083 472.247 318 491.764 318 512c0 35.834 9.666 69.41 26.532 98.265l-1.273 0.735-188.886-327.16zM890.723 317l0.035 0.067-233.125 64.14C621.951 341.774 570.37 317 513 317h377.724z"
                                  opacity=".047" p-id="4797"></path>
                            <path d="M317.594 512a195 195 0 1 0 390 0 195 195 0 1 0-390 0z" fill="#FFFFFF"
                                  p-id="4798"></path>
                            <path d="M357.594 512a155 155 0 1 0 310 0 155 155 0 1 0-310 0z" fill="#4A8AF4"
                                  p-id="4799"></path>
                        </svg>-->
                    </div>
                    <div v-if="christmas_decoration===1" class="snow1"></div>
                    <div v-if="christmas_decoration===2" class="snow1_1"></div>
                    <b>Area aktivitas</b>
                </div>
            </div>
            <div id="forPop" v-if="is_bind" @click="bgClose"></div>
            <div v-if="is_bind" class="google-bind">
                <div v-if="show_google_bind" style="text-align: center;margin-top: 50px" class="row-wrap">
                    <p>
                        <svg style="font-size: 1.2rem" t="1634639923210" class="icon" viewBox="0 0 1024 1024"
                             version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2447" width="200" height="200">
                            <path d="M950.272 153.088c-13.312-10.752-30.208-16.896-48.128-16.896h-5.12c-1.024 0-12.288 0.512-30.208 0.512-29.696 0-87.04-1.536-141.824-13.824-70.656-15.36-152.064-86.016-175.616-100.352-11.776-7.168-25.6-10.752-39.424-10.752s-27.648 3.584-39.424 10.752c-3.072 1.536-88.064 81.92-171.52 100.352-54.784 11.776-113.152 13.824-142.848 13.824-17.92 0-29.184-0.512-30.208-0.512h-4.608c-17.92 0-35.328 6.144-48.64 16.896-14.336 11.776-22.528 28.16-22.528 45.568v156.16c0 578.048 428.544 652.8 446.976 655.36 4.096 0.512 8.192 1.024 12.288 1.024s8.192-0.512 12.288-1.024c18.432-3.072 450.048-77.312 450.048-655.36V198.656c1.024-17.408-7.168-33.792-21.504-45.568z m-48.128 201.728c0 532.48-391.68 593.92-391.68 593.92s-388.608-61.44-388.608-593.92V198.656s13.312 1.024 35.328 1.024c37.376 0 99.84-2.56 159.744-15.36C414.72 162.816 510.464 75.264 510.464 75.264s99.84 87.552 198.144 109.056c59.904 12.8 121.344 15.36 158.72 15.36 21.504 0 35.328-1.024 35.328-1.024v156.16h-0.512zM730.624 322.56l-274.432 242.176-136.192-120.32c-16.896-14.848-44.544-14.848-61.44 0-16.896 14.848-16.896 38.912 0 54.272l158.72 140.288c2.048 3.072 4.096 5.632 6.656 8.192 8.704 7.68 20.48 11.264 31.744 11.264 11.264 0.512 23.04-3.584 31.744-11.264 2.56-2.56 5.12-5.12 7.168-8.192l296.96-262.144c16.896-14.848 16.896-38.912 0-54.272-16.384-14.848-44.032-14.848-60.928 0z"
                                  fill="#00C88D" p-id="2448"></path>
                        </svg>
                    </p>
                    <p><b><br>Google Authenticator</b><br><br></p>
                    <div class="google-authenticator-btn bg-color-blue" @click="bgClose">Close</div>
                </div>
                <div v-else class="row-wrap">
                    <div class="row">
                        <div class="row-name">Phone</div>
                        <input class="input" v-model="google.phone" readonly/>
                    </div>
                    <div class="row">
                        <div class="row-name">Secret</div>
                        <input class="input" v-model="google.secret" readonly/>
                    </div>
                    <div style="background-color: #fff;">
                        <div style="float: left;padding: 5px 15px;width:140px;">
                            <img width="100%" :src="google.img_url">
                        </div>
                        <div style="width: 70%;margin-left: 102px;padding-top: 5px">
                            <p>Scan the code or enter secret to get the code verification binding</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-name">Code</div>
                        <input class="input" placeholder="google verify code" v-model="google.code"/>
                    </div>
                    <div class="google-authenticator-btn bg-color-blue" @click="verifyBind">
                        <div>
                            <div style="float: left;">
                                <svg style="font-size: .6rem;position:absolute;margin-top: 6px;margin-left: 75px"
                                     t="1634613698906" class="icon" viewBox="0 0 1024 1024" version="1.1"
                                     xmlns="http://www.w3.org/2000/svg" p-id="5337" width="200" height="200">
                                    <path d="M0 511.5776C0 794.112 229.0176 1023.1552 511.5776 1023.1552c282.5472 0 511.5776-229.0304 511.5776-511.5776C1023.1552 229.0176 794.112 0 511.5776 0 229.0176 0 0 229.0176 0 511.5776z"
                                          fill="#656565" p-id="5338"></path>
                                    <path d="M766.848 805.3376a38.5664 38.5664 0 1 0 38.5408-38.5792c-21.5808 0.512-38.5536 17.472-38.5536 38.5792z"
                                          fill="#777777" p-id="5339"></path>
                                    <path d="M671.7184 512.2688v-0.512c0-88.4352-71.9616-159.8976-160.4096-159.8976-88.4352 0-159.36 71.9744-159.36 159.8976a159.424 159.424 0 0 0 21.9648 81.024l0.4096 0.6912 1.4464 2.3936 0.768 1.2416 1.1776 1.8304 1.0752 1.6384c0.32 0.4736 0.64 0.96 0.9856 1.4336 0.3328 0.4736 0.8576 1.2544 1.2416 1.8944l0.8576 1.1776 1.4848 2.048 0.768 1.0112 1.6128 2.112 0.7424 0.9472 1.7024 2.0864 0.7936 0.96c0.5632 0.6784 1.1264 1.3568 1.7024 2.0096l0.9344 1.0624c0.5504 0.6272 1.088 1.2544 1.6512 1.8688l1.152 1.2416 1.5104 1.6128a62.72 62.72 0 0 0 1.792 1.8432l0.9472 0.96L594.56 820.224a319.9744 319.9744 0 0 0 236.544-307.9424H671.7184z"
                                          fill="#4D4D4D" p-id="5340"></path>
                                    <path d="M511.8208 831.5264a319.424 319.424 0 0 1-319.744-319.7824c0-175.808 141.8752-319.744 318.72-319.744a320.384 320.384 0 0 1 225.728 92.5824l135.7568-135.7696A511.744 511.744 0 0 0 511.5776 0C230.9376 0 0 230.9376 0 511.5776c0 280.64 230.9376 511.5776 511.5776 511.5776 80.0896 0 159.0656-18.816 230.5536-54.912L594.624 820.7232c-27.008 7.1936-54.848 10.8288-82.8032 10.816z"
                                          fill="#999999" p-id="5341"></path>
                                    <path d="M179.6736 805.3376a38.5664 38.5664 0 1 0 38.5664-38.5792c-21.5936 0.512-38.5664 17.472-38.5664 38.5792zM57.856 511.744a38.5536 38.5536 0 1 0 38.5536-38.5664c-21.5808 0.512-38.5536 17.472-38.5536 38.5664z m121.8176-293.568a38.5664 38.5664 0 1 0 77.1328 0.1024 38.5664 38.5664 0 0 0-77.1328-0.1024z m293.5936-121.856a38.5664 38.5664 0 1 0 38.5664-38.5536c-21.5936 0.512-38.5664 17.472-38.5664 38.5536z m0 830.848a38.5664 38.5664 0 1 0 77.1328 0.0128 38.5664 38.5664 0 0 0-77.1328-0.0256z"
                                          fill="#C1C1C1" p-id="5342"></path>
                                    <path d="M933.4144 559.5776H517.4912a47.808 47.808 0 0 1 0-95.6288h415.9232a47.808 47.808 0 1 1 0 95.616z"
                                          fill="#AFAFAF" p-id="5343"></path>
                                </svg>
                            </div>
                            <b>Verify Bind</b>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrapper">
            <div class="function">
                <div class="item bg-color-blue" @click="rechargMoney">
                    <div v-if="christmas_decoration===1" class="snow2"></div>
                    <div v-if="christmas_decoration===2" class="snow1_2"></div>
                    <div><img src="../../assets/images/funA.png" alt=""/></div>
                    <div>TOP-UP</div>
                </div>
                <div class="item  bg-color-yellow" @click="withdrawMoney">
                    <div v-if="christmas_decoration===1" class="snow3"></div>
                    <div v-if="christmas_decoration===2" class="snow1_3"></div>
                    <div><img src="../../assets/images/funB.png" alt=""/></div>
                    <div>Penarikan</div>
                </div>
            </div>


            <div class="myService" v-if="MyMenus.length" style="margin-bottom: 0.4rem">
                <!--<div class="title acea-row row-middle">我的服务</div>-->
                <div class="serviceList acea-row row-middle">
                    <template v-for="(item, index) in MyMenus">
                        <div class="item" :key="index" @click="goPages(index)" v-if="item.wap_url">
                            <div class="pictrue">
                                <img :src="item.pic"/>
                            </div>
                            <div>{{ item.name }}</div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div v-if="christmas_decoration===2" class="xy"></div>
        <div style="width: 100%;height: 1.5rem"></div>
        <div class="footer-line-height"></div>
        <SwitchWindow v-on:changeswitch="changeswitch" :switchActive="switchActive" :login_type="userInfo.login_type">
        </SwitchWindow>
    </div>
</template>
<script>
    import {getUser,getClubUser, getMenuUser, setUserAvatar,exchange_code, getGoogleSecret, googleAuthBind} from "@api/user";
    import SwitchWindow from "@components/SwitchWindow";
    import navTitle from "@components/navTitle";

    const NAME = "User";

    export default {
        name: NAME,
        components: {
            SwitchWindow,
            navTitle
        },
        props: {},
        data: function () {
            return {
                icon_moeny: this.global.moeny,
                userInfo: {},
                MyMenus: [],
                orderStatusNum: {},
                switchActive: false,
                is_club_user: false,
                club_points_info: '',
                isWeixin: false,
                avatar_flag: false,
                avatar_path: "../../user-avatar/",
                user_avatar_list: ['n1.png', 'n2.png', 'n3.png', 'n4.png', 'nv1.png', 'nv2.png', 'nv3.png', 'nv4.png'],
                switch_index: 0,
                christmas_decoration: 0,
                exchange_code: '',
                is_bind: false,
                show_google_bind: false,
                google: {
                    phone: '',
                    secret: '',
                    code: '',
                    img_url: 'loading.gif'
                }
                // FUN:[
                //   {
                //     id: 135,
                //     name: "我要推广",
                //     pic: "http://qny.tuchuang.mqllin.cn/FuT2KUddtShOUGAcLlOfpsS4S0Gj",
                //     url: "/pages/user_vip/index",
                //     wap_url: "/user/user_promotion",
                //   },
                //   {
                //     id: 135,
                //     name: "商城公告",
                //     pic: "http://qny.tuchuang.mqllin.cn/Fol_Tij42xrsqpYSsY1jZbNYPfQ8",
                //     url: "/pages/user_vip/index",
                //     wap_url: "/news_list",
                //   },
                //
                //   {
                //     id: 135,
                //     name: "用户须知",
                //     pic: "http://qny.tuchuang.mqllin.cn/FiLYu5ARD5wV-_WDuaO3Qv5wnscz",
                //     url: "/pages/user_vip/index",
                //     wap_url: "/user/usermessages",
                //   },
                //   {
                //     id: 135,
                //     name: "实名认证",
                //     pic: "http://qny.tuchuang.mqllin.cn/FgwOztBt7MGSQpQJ33Qv1MPLd4P_",
                //     url: "/pages/user_vip/index",
                //     wap_url: "/user/vip",
                //   },
                //
                //   {
                //     id: 135,
                //     name: "余额明细",
                //     pic: "http://qny.tuchuang.mqllin.cn/FqTpoZGhyzHHCz5WM4Krz_qO0bbq",
                //     url: "/pages/user_vip/index",
                //     wap_url: "user/bill/0",
                //   },
                //   {
                //     id: 135,
                //     name: "积分明细",
                //     pic: "http://qny.tuchuang.mqllin.cn/FmvBeS-4mhZz7GlnqkBp_SZgKnJ2",
                //     url: "/pages/user_vip/index",
                //     wap_url: "/user/integral",
                //   },
                //   {
                //     id: 135,
                //     name: "我的地址",
                //     pic: "http://qny.tuchuang.mqllin.cn/FpzzMuyjASiuhn3TIgAfPABFNnHu",
                //     url: "/pages/user_vip/index",
                //     wap_url: "/user/add_manage",
                //   },
                //   {
                //     id: 135,
                //     name: "榜单",
                //     pic: "http://qny.tuchuang.mqllin.cn/FpQ-3t4mdheZ8xrkxWFvDvseVsOg",
                //     url: "/pages/user_vip/index",
                //     wap_url: "/user/rank",
                //   },
                //   {
                //     id: 135,
                //     name: "我的客服",
                //     pic: "http://qny.tuchuang.mqllin.cn/FqkJhHxmkbTGg3XjhHevo4v0fqvJ",
                //     url: "/pages/user_vip/index",
                //     wap_url: "/customer/list",
                //   },
                //   // {
                //   //   id: 135,
                //   //   name: "设置",
                //   //   pic: "http://datong.crmeb.net/public/uploads/attach/2019/03/28/5c9ccc9934a7c.png",
                //   //   url: "/pages/user_vip/index",
                //   //   wap_url: "/user/vip",
                //   // },
                //
                // ]
            };
        },
        watch: {
            $route(n) {
                if (n.name === NAME) {
                    this.User();
                    this.ClubUser();
                    this.MenuUser();
                }
            }
        },
        mounted: function () {
            this.User();
            this.ClubUser();
            this.MenuUser();
            // this.isWeixin = isWeixin();
        },
        methods: {
            goActivityArea: function () {
                this.$router.push({path: "/activity-area"});
            },
            changeAvatar: function () {
                this.avatar_flag = !this.avatar_flag
            },
            switchItem: function (item, index) {
                this.switch_index = index
                let that = this
                this.$dialog.confirm({
                    mes: 'Konfirmasikan untuk memilih avatar ini',
                    title: 'Ubah avatar',
                    opts: [
                        {
                            txt: 'Membatalkan',
                            color: false,
                            callback: () => {
                                that.avatar_flag = !that.avatar_flag
                                return that.$dialog.toast({mes: 'Batalkan kesuksesan'});
                            }
                        },
                        {
                            txt: 'Mengonfirmasi',
                            color: "#00C3F9",
                            callback: () => {
                                that.$dialog.loading.open('loading...')
                                setUserAvatar({avatar: item}).then(res => {
                                    // console.log(res)
                                    that.avatar_flag = !that.avatar_flag
                                    that.userInfo.avatar = item
                                    that.$dialog.loading.close();
                                    that.$dialog.toast({mes: res.msg})
                                }).catch(res => {
                                    // console.log(res)
                                    that.$dialog.loading.close();
                                    that.$dialog.toast({mes: res.msg});
                                });
                            }
                        }
                    ]
                });
            },
            rechargMoney: function () {
                this.$router.push({path: "/user/Recharge_cash"});
            },
            withdrawMoney: function () {
                this.$router.push({path: "/user/user_cash_public"});
            },
            changeswitch: function (data) {
                this.switchActive = data;
            },
            User: function () {
                let that = this;
                getUser().then(res => {
                    that.userInfo = res.data;
                    that.orderStatusNum = res.data.orderStatusNum;
                    that.localStorage.set('is_promoter', res.data.is_promoter)
                });
            },
            ClubUser: function () {
                let that =this
                getClubUser().then(res => {
                    // console.log(res)
                    that.christmas_decoration = res.data.christmas_decoration
                    that.is_club_user = res.data.is_activation
                    that.club_points_info = res.data.club_points_info
                });
            },
            MenuUser: function () {
                let that = this;
                getMenuUser().then(res => {
                    that.MyMenus = res.data.routine_my_menus;
                });
            },
            goPages: function (index) {
                let url = this.MyMenus[index].wap_url;
                let title = this.MyMenus[index].name;
                // if (url === "/user/user_promotion" && this.userInfo.statu === 1) {
                //   if (!this.userInfo.is_promoter)
                //     return this.$dialog.toast({ mes: "您还没有推广权限！！" });
                // }
                // if (url === "/customer/index" && !this.userInfo.adminid) {
                //   return this.$dialog.toast({ mes: "您还不是客服！！" });
                // }

                // if (url === "/user/user_promotion" && this.userInfo.status === 0) {
                //     this.$dialog.toast({ mes: "You have been disabled by your administrator" });
                //     this.$router.push({path: 'login'});
                // }
                if (url === "/user/user_promotion") {
                    this.User()
                    if (this.userInfo.status === 0) {
                        this.$dialog.toast({mes: "You have been disabled by your administrator"});
                        this.$router.push({path: 'login'});
                    }
                }

                this.$router.push({
                    path: this.MyMenus[index].wap_url,
                    query: {ti: title}
                });
            },
            goPagesLocal: function (index) {
                let url = this.FUN[index].wap_url;
                if (url === "/user/user_promotion" && this.userInfo.statu === 1) {
                    if (!this.userInfo.is_promoter)
                        return this.$dialog.toast({mes: "Unauthorised to promote！"});
                }
                if (url === "/customer/index" && !this.userInfo.adminid) {
                    return this.$dialog.toast({mes: "You are not a customer service！"});
                }

                this.$router.push({path: this.FUN[index].wap_url});
            },
            exchangeCode: function () {
                if (this.exchange_code === '') {
                    return this.$dialog.toast({mes: "Please fill in the exchange code"});
                }
                let that = this
                exchange_code({verification_code: that.exchange_code}).then(res => {
                    that.$dialog.success(res.msg);
                    that.User();
                }).catch(res => {
                    that.$dialog.error(res.msg);
                });
            },
            googleBind: function () {
                let that = this
                that.is_bind = !that.is_bind
                this.google.phone = this.userInfo.phone
                if (that.google.secret === '') {
                    getGoogleSecret().then(res => {
                        // console.log(res)
                        if (res.data.is_bind === 1) {
                            that.show_google_bind = true
                        } else {
                            that.google.img_url = res.data.qr_code
                            that.google.secret = res.data.secret
                        }
                    })
                }
            },
            verifyBind: function () {
                let that = this
                if (this.google.code === '') {
                    return this.$dialog.toast({mes: "Please fill in the google verify code"});
                }
                let data = {phone: this.google.phone, secret: this.google.secret, code: this.google.code}
                googleAuthBind(data).then(res => {
                    that.show_google_bind = true
                    // that.is_bind = false
                    return that.$dialog.toast({mes: res.msg});
                }).catch(res => {
                    return that.$dialog.toast({mes: res.msg});
                })
                // console.log(this.google)
            },
            bgClose: function () {
                // this.google.secret = ''
                // this.google.img_url = 'loading.gif'
                this.is_bind = false
            }
        }
    };
</script>

<style scoped>
    .footer-line-height {
        height: 1rem;
    }

    .order-status-num {
        min-width: 0.33rem;
        background-color: #fff;
        color: #ee5a52;
        border-radius: 15px;
        position: absolute;
        right: -0.14rem;
        top: -0.15rem;
        font-size: 0.2rem;
        padding: 0 0.08rem;
        border: 1px solid #ee5a52;
    }

    .pictrue {
        position: relative;
    }

    .switch-h5 {
        margin-left: 0.2rem;
    }

    .binding {
        padding: 0.05rem 0.2rem;
        background-color: #ca1f10;
        border-radius: 50px;
        font-size: 0.14rem;
        border: 1px solid #e8695e;
        color: #ffffff;
    }

    .function {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 0.15rem;
    }

    .function .item {
        width: 49%;
        height: 2.448rem;
        padding: 0.75rem 0;
        box-sizing: border-box;
        color: #fff;
        text-align: center;
        border-radius: 0.15rem;
    }

    .function .item img {
        width: 0.45rem;
        margin-bottom: 0.2rem;
    }

    .function .bg-color-blue {
        background: #00c3f9;
    }

    .function .bg-color-yellow {
        background: #fcbb01;
    }

    .user-info {
        width: 100%;
        height: 3.53rem;
        background: #fff;
        border-radius: 0.15rem;
        /*background: url("../../assets/images/userBack.png") no-repeat;*/
        /*background-size: 100% 100%;*/
        padding: 0.47rem 0.63rem 0rem 0.63rem;
        box-sizing: border-box;
    }

    .user-head {
        width: 100%;
        display: flex;
        margin-bottom: 0.5rem;
    }

    .user-avatar {
        width: 1.25rem;
        height: 1.25rem;
        border-radius: 50%;
        overflow: hidden;
        position: relative;
    }

    .bg{
        -webkit-box-shadow: 2px 2px 10px #00c3f9;
        box-shadow: 2px 2px 10px #00c3f9;
    }

    .crown {
        width: 2rem;
        margin-left: -.438rem;
        margin-top: -.3rem;
        position: absolute; /* 绝对定位 */
        /*top: -.7rem; !* 位于父容器顶部 *!*/
        /*left: -.2rem; !* 位于父容器左侧 *!*/
        z-index: 400; /* 设置一个比头像图片更高的z-index，以确保它显示在上方 */
    }

    .hat{
        width: 2rem;
        margin-left: -.35rem;
        margin-top: -.56rem;
        position: absolute; /* 绝对定位 */
        z-index: 400;
    }

    .hat1{
        width: 1.6rem;
        margin-left: -.18rem;
        margin-top: -.18rem;
        position: absolute; /* 绝对定位 */
        z-index: 400;
    }

    /*.avatar {
        border-radius: 50%;
        position: absolute; !* 绝对定位 *!
        top: 0; !* 位于父容器顶部 *!
        left: 0; !* 位于父容器左侧 *!
        z-index: 0; !* 默认z-index，位于皇冠下方 *!
    }*/

    .user-avatar img {
        width: 100%;
        height: 100%;
    }

    .vip-icon {
        width: 0.28rem;
        height: 0.28rem;
        font-size: 0.2rem;
        margin-right: 0.08rem;
    }

    .user-name {
        width: 4.34rem;
        color: rgba(255, 255, 255, 1);
        margin-left: 0.35rem;
        text-align: left;
        color: #333333;

        /*display: flex;*/
    }

    .user-name a {
        display: block;
    }

    .user-name .name {
        font-size: 0.32rem;
        max-width: 2.6rem;
        width: unset;
    }

    .user-name .member {
        padding: 0 0.1rem;
        height: 0.36rem;
        background-color: rgba(0, 0, 0, 0.2);
        font-size: 0.2rem;
        border-radius: 0.3rem;
        margin-left: 0.17rem;
        color: #444444;
    }

    .user-currency {
        width: 100%;
        /*height: 2rem;*/
        display: flex;
    }

    .user-currency .currency {
        flex: 1;
        position: relative;
        text-align: center;
    }

    .user-currency .currency .integral {
        font-size: 0.455rem;
        color: #333;
    }

    .user-currency .currency .currency-name {
        font-size: 0.25rem;
        color: #999;
    }

    .user-currency .currency:first-child::after {
        width: 1px;
        height: 50%;
        position: absolute;
        right: 0px;
        top: 50%;
        transform: translateY(-50%);
        background: #ccc;
    }

    .bindingPhone {
        width: 100%;
        color: #999;
        text-align: center;
        border-radius: 0.05rem;
        background: #f6f7f8;
        padding: 0.05rem;
        /*text-decoration: underline;*/
    }

    .headerbg {
        width: 100%;
        height: 1.5rem;
        position: absolute;
        top: 1rem;
        z-index: -1;
    }

    .headerbg:after {
        position: absolute;
        left: 0;
        right: 0;
        bottom: -0.98rem;
        z-index: -1;
        content: "";
        height: 1rem;
        width: 100%;
        border-radius: 0 0 10% 10%;
        background-color: #00c3f9;
    }

    .avatar_flag {
        -moz-box-shadow: 2px 2px 10px #00c3f9;
        -webkit-box-shadow: 2px 2px 10px #00c3f9;
        box-shadow: 2px 2px 10px #00c3f9;

        /*padding: 0.5px 2px;*/
        background-color: #fff;
        position: absolute;
        z-index: 999;
        width: 335px;
        height: 165px;
        margin-left: 2%;
        margin-top: 20%;
        border: 1px solid #ccc;

        display: flex;
        flex-wrap: wrap;

        box-sizing: border-box;
        /*background: #fff;*/
        border-radius: 3px;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
    }

    .avatar_flag .switch-item:nth-child(3n) {
        margin-right: 0px;
    }

    .switch-click {
        border: 1px solid #00c3f9 !important;
        color: #00c3f9 !important;

    }

    .avatar-item {
        /*border: 1px solid red;*/
        /*background-color: #f0f1f3;*/
        float: left;
        /*margin: 2px;*/
        /*padding   : 1px;*/
    }

    .google-authenticator-btn {
        display: block;
        width: 5.5rem;
        height: 0.86rem;
        margin: 0.5rem auto 0 auto;
        line-height: 0.86rem;
        text-align: center;
        color: #fff;
        border-radius: 0.15rem;
        font-size: 0.3rem;
        font-weight: bold;
    }

    .bg-color-blue {
        background-color: #00c3f9 !important;
    }

    .row-T1 {
        width: 100%;
        height: 1rem;
        line-height: 1rem;
        padding-left: 0.27rem;
        box-sizing: border-box;
    }

    .row-info {
        width: 100%;
        height: 0.5rem;
        line-height: 0.5rem;
        padding-left: 0.27rem;
        box-sizing: border-box;
        color: #999;
        margin-top: -10px;
    }

    .row-error {
        width: 100%;
        box-sizing: border-box;
        color: #ff3c2b;
        margin-top: -10px;
    }

    .row {
        width: 100%;
        padding: 0 0.27rem;
        box-sizing: border-box;
        background: #fff;
        height: 0.75rem;
        line-height: 0.75rem;
        display: flex;
        position: relative;
    }

    .row::after {
        content: "";
        position: absolute;
        width: calc(100% - 0.27rem - 0.27rem);
        bottom: 0px;
        left: 0;
        right: 0;
        margin: 0 auto;
        height: 1px;
        background: #eee;
    }

    .row .row-name {
        width: 2.5rem;
    }

    .row .input {
        flex: 1;
        display: block;
        height: 0.75rem;
        line-height: 0.75rem;
        box-sizing: border-box;
        padding-left: 0.15rem;
        border: none;
        background: #fff;
    }

    .row .select {
        flex: 1;
        display: block;
        height: 0.75rem;
        line-height: 0.75rem;
        box-sizing: border-box;
        padding-left: 0.15rem;
        border: none;
        background: #fff;
    }

    .google-bind {
        z-index: 1000;
        background-color: #fff;
        width: 350px;
        height: 370px;
        border-radius: 5px;
        /*border: #888888 2px solid;*/
        position: fixed;
        left: 50%;
        top: 50%;
        margin-top: -210px;
        margin-left: -175px;
        padding-top: 10px;
    }

    #forPop {
        z-index: 999;
        width: 100%;
        height: 1000px;
        top: 0px;
        left: 0px;
        position: absolute;
        /*因为IE不支持opacity 所以用filter 为了兼容两个都写*/
        filter: Alpha(opacity=60);
        opacity: 0.6;
        background: #000000;
    }

    .flex-container {
        margin-top: 20px;
        display: -webkit-flex;
        display: flex;
        -webkit-justify-content: space-around;
        justify-content: space-around;
        background-color: #fff;
        width: 100%;
        padding: 8px 3px;
        border-radius: 5px;
    }

    .button1 {
        background: rgb(0, 195, 249);
        color: #fff;
        padding: 2px;
        border-radius: 5px;
    }

    /*圣诞*/
    .decorate{
        /*border: 1px solid red;*/
        position: absolute;
        z-index: 100;
        width: 100%;
        height: 150px;
        background-image: url("../../assets/images/decorate.gif");
        background-size: contain;
        /*background-repeat: no-repeat;*/
        /*background-position: center;*/
        pointer-events: none;
    }
    .decorate1{
        position: absolute;
        z-index: 100;
        width: 100%;
        height: 130px;
        background-image: url("../../assets/images/year/new_year3.gif");
        background-size: contain;
        pointer-events: none;
    }
    .snow1{
        position: absolute;
        width: 5.5rem;
        height: 30px;
        background-image: url("../../assets/images/snow5.png");
        background-size: contain;
        /*background-repeat: no-repeat;*/
        background-position: center;
        margin-top: -12px;
    }
    .snow2{
        position: absolute;
        width: 1.2rem;
        height: 40px;
        background-image: url("../../assets/images/snow6.png");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        margin-top: -50px;
        margin-left: -5px;
    }
    .snow3{
        /*border: 1px solid red;*/
        position: absolute;
        width: 1.2rem;
        height: 40px;
        background-image: url("../../assets/images/snow2.png");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        margin-top: -50px;
        right: 0;
        margin-right: 3px;
    }
    .snow1_1{
        position: absolute;
        width: 5.5rem;
        height: 90px;
        background-image: url("../../assets/images/year/new_year7.gif");
        background-size: contain;
        /*background-repeat: no-repeat;*/
        background-position: center;
        margin-top: -80px;
    }
    .snow1_2{
        position: absolute;
        width: 1.2rem;
        height: 40px;
        background-image: url("../../assets/images/snow6.png");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        margin-top: -50px;
        margin-left: -5px;
    }
    .snow1_3{
        /*border: 1px solid red;*/
        position: absolute;
        width: 1.2rem;
        height: 40px;
        background-image: url("../../assets/images/snow2.png");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        margin-top: -50px;
        right: 0;
        margin-right: 3px;
    }
    .xy{
        position: absolute;
        width: 100%;
        height: 180px;
        background-image: url("../../assets/images/year/xy.gif");
        background-size: contain;
        /*background-repeat: no-repeat;*/
        background-position: center;
        margin-top: -100px;
        pointer-events: none;
        transform: rotate(180deg);
    }

</style>